// AUTO-GENERATED by scripts/build-archival-photos-index.mjs — DO NOT EDIT BY HAND.
export const ARCHIVAL_PHOTOS_COUNT = 4819;
